export default __webpack_public_path__ + "static/media/bg-texture.037a7e51.jpeg";